export function normalizeControllerType(...sources) {
  for (const source of sources) {
    const token = String(source || '').trim().toLowerCase().replace(/_/g, '-');
    if (!token) continue;
    if (['climate', 'water', 'soil', 'generic'].includes(token)) return token;
    if (/climate|air|hvac|humid|co2/.test(token)) return 'climate';
    if (/water|hydro|tank|pump|valve|waterinandout|water-in-out/.test(token)) return 'water';
    if (/soil|moisture|7in1|7-in-1/.test(token)) return 'soil';
  }
  return 'generic';
}

export function getControllerType(deviceLike = {}) {
  return normalizeControllerType(
    deviceLike.controllerType,
    deviceLike.controller,
    deviceLike.deviceType,
    deviceLike.type,
    deviceLike.kind
  );
}

export function getDeviceOwnership(deviceLike = {}) {
  const explicit = String(deviceLike.ownership || '').trim().toLowerCase();
  if (['room', 'farm_unassigned', 'global_unclaimed'].includes(explicit)) return explicit;
  const hasFarm = deviceLike.farmId != null && String(deviceLike.farmId).trim() !== '';
  const hasRoom = deviceLike.roomId != null && String(deviceLike.roomId).trim() !== '';
  if (!hasFarm) return 'global_unclaimed';
  return hasRoom ? 'room' : 'farm_unassigned';
}
